// src/store/serviceStore.js
import { create } from "zustand";
import { fetchServices } from "../api/serviceApi";
import { toast } from "react-toastify";
import axiosToken from "../api/axiosClient";

export const useServiceStore = create((set, get) => ({
  services: [],
  isLoading: false,
  error: null,


  // Fonctions pour synchroniser avec les catégories
  syncCategoryCreate: (newCategory) => {
    set(state => ({
      servicesGroupByCategory: {
        ...state.servicesGroupByCategory,
        [newCategory.name]: {
          category: newCategory,
          services: []
        }
      }
    }));
  },


  syncCategoryUpdate: (categoryId, newValues) => {
    set(state => ({
      servicesGroupByCategory: Object.keys(state.servicesGroupByCategory).reduce((acc, categoryName) => {
        const categoryData = state.servicesGroupByCategory[categoryName];
        if (categoryData.category.id === categoryId) {
          return {
            ...acc,
            [newValues.name || categoryName]: {
              ...categoryData,
              category: {
                ...categoryData.category,
                name: newValues.name || categoryName,
                description: newValues.description || categoryData.description,
              }
            }
          };
        }
        return {
          ...acc,
          [categoryName]: categoryData
        };
      }, {})
    }));
  },

  syncCategoryStatusChange: (categoryId, newStatus) => {
    set(state => ({
      servicesGroupByCategory: Object.keys(state.servicesGroupByCategory).reduce((acc, categoryName) => {
        const categoryData = state.servicesGroupByCategory[categoryName];
        if (categoryData.category.id === categoryId) {
          return {
            ...acc,
            [categoryName]: {
              ...categoryData,
              category: {
                ...categoryData.category,
                isActive: newStatus
              }
            }
          };
        }
        return {
          ...acc,
          [categoryName]: categoryData
        };
      }, {})
    }));
  },

  loadServices: async () => {
    set({ isLoading: true, error: null });
    try {
      const data = await fetchServices();
      set({ services: data, isLoading: false });
    } catch (err) {
      set({ error: err.message, isLoading: false });
    }
  },

  getLimitedServices: (limit = 6) => {
    get().services.slice(0, limit);
  },
  getServiceById: async (id) => {
    if (get().services.length < 1) {
      await get().loadServices();
    }
    return get().services.find((service) => service.id === id);
  },

  
  servicesGroupByCategory: {},
  isLoadingServicesGroupByCategory: false,
  // Récupérer les services groupés par catégorie
  getServicesGroupByCategorie: async () => {

    set({ isLoadingServicesGroupByCategory: true });

    try {
      const response = await axiosToken.get(`/service/group/by/category`);
      set({ servicesGroupByCategory: response.data, isLoadingServicesGroupByCategory: false });
      return response.data;
    } catch (error) {
      console.error("Erreur getServicesGroupByCategorie :", error);
      toast.error(error?.response?.data?.error || "Erreur lors du chargement des services groupés par catégorie.");
      set({ isLoadingServicesGroupByCategory: false });
      return null;
    }
  },


  changeStatusServiceLoading: false,
  // Activation/Désactivation  d'un service
  changeStatusService: async (service) => {
    console.log(`${service.is_active ? "Désactivation" : "Activation"} du service.`)
    console.log(`/service/${service.is_active ? "disable" : "enable"}/${service.id}`);

    set({ changeStatusServiceLoading: true });

    try {
      const response = await axiosToken.put(`/service/${service.is_active ? "disable" : "enable"}/${service.id}`);
      set({ changeStatusServiceLoading: false });

      // Mettre à jour l'état local
      set(state => ({
        services: state.services.map(s =>
          s.id === service.id
            ? { ...s, is_active: !service.is_active }
            : s
        ),
        servicesGroupByCategory: Object.keys(state.servicesGroupByCategory).reduce((acc, categoryName) => {
          const categoryData = state.servicesGroupByCategory[categoryName];
          return {
            ...acc,
            [categoryName]: {
              ...categoryData,
              services: categoryData.services.map(s =>
                s.id === service.id
                  ? { ...s, is_active: !service.is_active }
                  : s
              )
            }
          };
        }, {}),
      }));

      toast.success(`Service ${service.is_active ? "désactivé" : "activé"} avec succès`);
      return response.data;
    } catch (error) {
      console.error("Erreur changeStatusService :", error);
      toast.error(error?.response?.data?.error || `Erreur lors de ${service.is_active ? "la désactivation" : "l'activation"} du service.`);
      set({ changeStatusServiceLoading: false });
      return null;
    }
  },

}));


export const useCategoryStore = create((set, get) => ({
  allCategory: [],
  isLoadingCategory: false,

  // Récupérer les catégories
  getCategorie: async () => {
    set({ isLoadingCategory: true });

    try {
      const response = await axiosToken.get(`/service/category`);
      set({
        allCategory: response.data,
        isLoadingCategory: false
      });
      return response.data;
    } catch (error) {
      console.error("Erreur getCategorie :", error);
      toast.error(error?.response?.data?.error || "Erreur lors du chargement des catégories.");
      set({ isLoadingCategory: false });
      return null;
    }
  },

  // Créer une catégorie
  categoryAddLoading: false,
  createCategory: async (categoryData) => {
    set({ categoryAddLoading: true });
    try {
      const response = await axiosToken.post('/service/category', categoryData);

      const serviceStore = useServiceStore.getState();
      serviceStore.syncCategoryCreate(categoryData);

      // Mettre à jour la liste des catégories
      set(state => ({
        allCategory: [...state.allCategory, response.data.data],
        categoryAddLoading: false,
      }));

      toast.success("Catégorie créée avec succès");
      return response.data;
    } catch (error) {
      console.error("Erreur createCategory :", error);
      toast.error(error?.response?.data?.error || "Erreur lors de la création de la catégorie.");
      set({ categoryAddLoading: false });
    }
  },

  // Modifier une catégorie
  categoryUpdateLoading: false,
  updateCategory: async (categoryId, categoryData) => {
    console.log({ categoryId, categoryData });

    set({ categoryUpdateLoading: true });
    try {
      const response = await axiosToken.put(`/service/category/${categoryId}`, categoryData);

      const serviceStore = useServiceStore.getState();
      serviceStore.syncCategoryUpdate(categoryId, categoryData);

      // Mettre à jour la liste des catégories
      set(state => ({
        allCategory: state.allCategory.map(cat =>
          cat.id === categoryId ? response.data.data : cat
        ),
        categoryUpdateLoading: false,
      }));

      toast.success("Catégorie modifiée avec succès");
      return response.data;
    } catch (error) {
      console.error("Erreur updateCategory :", error);
      toast.error(error?.response?.data?.error || "Erreur lors de la modification de la catégorie.");
      set({ categoryUpdateLoading: false });
      throw error;
    }
  },

  // Changer le statut d'une catégorie
  changeStatusCategoryLoading: false,
  changeCategoryStatus: async (category) => {
    set({ changeStatusCategoryLoading: true });
    try {
      console.log(`/service/category/${category.id}/status`);

      const response = await axiosToken.put(`/service/category/${category.id}/status`, {
        status: category.isActive ? 'disable' : 'enable'
      });

      const serviceStore = useServiceStore.getState();
      serviceStore.syncCategoryStatusChange(category.id, !category.isActive);

      // Mettre à jour la liste des catégories
      set(state => ({
        allCategory: state.allCategory.map(cat =>
          cat.id === category.id ? { ...cat, isActive: !category.isActive } : cat
        ),
        changeStatusCategoryLoading: false
      }));

      toast.success(`Catégorie ${!category.isActive ? 'activée' : 'désactivée'} avec succès`);
      return response.data;
    } catch (error) {
      console.error("Erreur changeCategoryStatus :", error);
      toast.error(error?.response?.data?.error || `Erreur lors de ${!category.isActive ? "l'activation" : "la désactivation"} de la catégorie.`);
      set({ changeStatusCategoryLoading: false });
  }
  },

}));

